export const formatCurrency = (value, lang) => {
	const formattedValue = new Intl.NumberFormat(lang, {
		style: "currency",
		currency: "EUR",
	}).format(value);

	return formattedValue;
};

export const getValues = (obj) => {
	let values = [];

	for (let key in obj) {
		if (typeof obj[key] === "object") {
			values = values.concat(getValues(obj[key]));
		} else if (typeof obj[key] === "number") {
			values.push(obj[key]);
		}
	}

	return values;
};
